import "@assets/css/bootstrap-grid.css";
import React from "react";
import EnterpriseTestimonialForm from "./testimonial.form";

const TestimonialForm: React.FC = () => {
  return (
    <>
      <EnterpriseTestimonialForm />
    </>
  );
};

export default TestimonialForm;
